import React, { ReactNode } from 'react';

import { AuthProvider } from './auth';
import { ColumnModalProvider } from './columnModal';
import { ColumnsProvider } from './columns';
import { CreateReportProvider } from './createReport';
import { FilterModalProvider } from './filterModal';
import { FiltersProvider } from './filters';
import { GroupModalProvider } from './groupModal';
import { GroupsProvider } from './groups';
import { SelecionaParceiroFilhoModalProvider } from './SelecionaParceiroFilhoModalContext';
import { SidebarDrawerProvider } from './sidebarDrawer';

interface IAppProvider {
  children: ReactNode;
}

const AppProvider: React.FC<IAppProvider> = ({ children }: IAppProvider) => (
  <AuthProvider>
    <SelecionaParceiroFilhoModalProvider>
      <SidebarDrawerProvider>
        <FilterModalProvider>
          <ColumnModalProvider>
            <GroupModalProvider>
              <FiltersProvider>
                <ColumnsProvider>
                  <GroupsProvider>
                    <CreateReportProvider>{children}</CreateReportProvider>
                  </GroupsProvider>
                </ColumnsProvider>
              </FiltersProvider>
            </GroupModalProvider>
          </ColumnModalProvider>
        </FilterModalProvider>
      </SidebarDrawerProvider>
    </SelecionaParceiroFilhoModalProvider>
  </AuthProvider>
);

export default AppProvider;
